import { createTypes } from 'reduxsauce'
 
export default createTypes(`
  MODIFY_PAGINATION

  RESET

`, {});
